import angular from "angular";
import authRouteConfig from "./auth.route";
import authCtrl from "./auth.controller";

export default angular
    .module("sbApp.authModule", ["ui.router", "sbApp.intercom"])
    .config(authRouteConfig)
    .controller("AuthCtrl", authCtrl);
/* declaration */
